import { render, staticRenderFns } from "./BacklogView.vue?vue&type=template&id=26bc845e&scoped=true"
import script from "./BacklogView.vue?vue&type=script&lang=js"
export * from "./BacklogView.vue?vue&type=script&lang=js"
import style0 from "./BacklogView.vue?vue&type=style&index=0&id=26bc845e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc845e",
  null
  
)

export default component.exports